import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { EjecutivoService } from '../../../services/EjecutivoService';

const EjecutivoForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Options states
  const [sucursalesOptions, setSucursalesOptions] = useState([]);

  // Load sucursales options
  useEffect(() => {
    let isMounted = true;
    const fetchOptions = async () => {
      const sucursales = await EjecutivoService.obtenerSucursales();
      if (isMounted && Array.isArray(sucursales)) {
        setSucursalesOptions(sucursales);
      }
    };
    fetchOptions();
    return () => {
      isMounted = false;
    };
  }, []);

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await EjecutivoService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
      id_sucursal: values.id_sucursal ? Number(values.id_sucursal) : values.id_sucursal,
    };
    return await EjecutivoService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'ejecutivo',
      label: 'Clave',
      type: 'text',
      col: 4,
      required: true,
      placeholder: 'Ej. EJ-01',
      validators: [Validators.required('La clave del ejecutivo es obligatoria')],
    },
    {
      name: 'ejecutivo_nombre',
      label: 'Nombre',
      type: 'text',
      col: 4,
      required: true,
      placeholder: 'Ej. Juan Pérez',
      validators: [Validators.required('El nombre del ejecutivo es obligatorio')],
    },
    {
      name: 'id_sucursal',
      label: 'Sucursal',
      type: 'select',
      col: 4,
      required: true,
      options: sucursalesOptions,
      placeholder: 'Seleccionar sucursal...',
      validators: [Validators.required('La sucursal es obligatoria')],
    },
  ], [sucursalesOptions]);

  return (
    <CatalogForm
      title="Ejecutivo"
      subtitle="Administración de ejecutivos de cuenta y asignación de sucursal"
      fields={fields}
      initialValues={{
        ejecutivo: '',
        ejecutivo_nombre: '',
        id_sucursal: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Ejecutivos"
    />
  );
};

export default EjecutivoForm;
